import React from 'react'
import { t } from 'ttag'

import { Button } from 'components/shared/Button/Button'

import { PlusCircleIcon } from 'components/shared/Icon/model'

import styles from './NewCategoryButton.module.scss'

export const NewCategoryButton = ({ onClick, isDisabled }) => (
  <Button
    className={styles.button}
    icon={PlusCircleIcon}
    label={t`Add new category`}
    size="medium"
    variant="outlined"
    isFullWidth
    {...{ onClick, isDisabled }}
  />
)
